import {
  ComposedChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import React from "react";

// const data = [
//   { month: "Jan", income: 4000, trend: 2400 },
//   { month: "Feb", income: 3000, trend: 212 },
//   { month: "Mar", income: 2000, trend: 800 },
//   { month: "Apr", income: 2780, trend: 3908 },
//   { month: "May", income: 1890, trend: 2800 },
//   { month: "Jun", income: 2390, trend: 3800 },
//   { month: "Jul", income: 1390, trend: 3800 },
//   { month: "Aug", income: 5390, trend: 3800 },
//   { month: "Sep", income: 9390, trend: 4800 },
//   { month: "Oct", income: 2390, trend: 3800 },
//   { month: "Nov", income: 390, trend: 1800 },
//   { month: "Dec", income: 10390, trend: 3800 },
// ];

const Chart = ({ data }: { data: any }) => (
  <ResponsiveContainer width="100%" height={400}>
    <ComposedChart data={data}>
      <CartesianGrid stroke="#f5f5f5" />
      <XAxis dataKey="month" />
      <YAxis />
      <Tooltip />
      <Legend />
      <Bar dataKey="amount" name="Income" barSize={100} fill="#6091E6" />
      <Line
        type="monotone"
        dataKey="amount"
        name="Trend"
        stroke="#66D25E"
        strokeWidth={3}
      />
    </ComposedChart>
  </ResponsiveContainer>
);

export default Chart;
